'use strict';

var React = require('react');
var classNames = require('classnames');
//components
var SectionHeader = require('../Common/SectionHeader.jsx');
var RadioInput = require('../Common/RadioInput.jsx');
var RadioButtonList = require('../Common/RadioButtonList.jsx');
var InvestorRebateAccountOption = require('./InvestorRebateAccountOption.jsx').default;

//constants
var ApplicationConstants = require('../../constants/ApplicationConstants.js');
var PortfolioRebateConstants = require('../../constants/PortfolioRebateConstants.js');

//stores
var PortfolioRebateStore = require('../../stores/PortfolioRebateStore.js');

//actions
var PortfolioRebateActions = require('../../actions/PortfolioRebateActions.js');
var ApplicationActions = require('../../actions/ApplicationActions.js');

//utils
var Screen = require('../../utils/Screen.js');
var Products = require('../../utils/Products.js');
var _ = require('lodash');

function getStateFromStores() {
    return {
        hideInvestmentOptionList: true,
        rebatableOptionList: PortfolioRebateStore.getRebatableList(),        
        portfolioRebateData: PortfolioRebateStore.getPortfolioRebateData(),
        errorList: PortfolioRebateStore.getErrorList(),
        isSelectOptionDisabled: PortfolioRebateStore.getIsSelectOptionDisabled()
    };
}

var PortfolioRebateSection = React.createClass({
    getInitialState: function () {
        return getStateFromStores();
    },

    // Add change listeners to stores
    componentDidMount: function () {
        PortfolioRebateStore.addChangeListener(this._onChange);
    },

    // Remove change listers from stores
    componentWillUnmount: function () {
        PortfolioRebateStore.removeChangeListener(this._onChange);
    },

    //Event handler for 'change' events coming from the stores
    _onChange: function () {
        this.setState(getStateFromStores());
    },

    componentWillUpdate: function (nextProps, nextState) {
        if (!_.isEqual(nextState, this.state)) {
            setTimeout(function () {
                ApplicationActions.sendPortfolioRebateDetails(nextState);
            }, 0);
        }
    },

    handlePortfolioRebateOptionChange: function (e) {
        var value = e.target.value;
        if (value !== '') {
            this.setState({ hideInvestmentOptionList: value === PortfolioRebateConstants.PortfolioRebateValues.MORE_CONSERVATIVE});
            PortfolioRebateActions.updatePortfolioRebateData({ portfolioRebateOption: value, investmentOption:'' });
        }
    },

    handleInvestmentOptionChange: function (e) {
        var value = e.target.value;
        PortfolioRebateActions.updatePortfolioRebateData({investmentOption: value });
    },
    
    getCopyText: function (productId, portfolioRebateContent) {
        if (Products.isInvestment(productId)) {
            return {
                sectionName: portfolioRebateContent.investmentSectionHeader,
                helpText: portfolioRebateContent.investmentHelp,
                labelText: 'Which investment option would you like any management cost rebate (portfolio rebate) to be credited to, if applicable?',
                noteText: portfolioRebateContent.investmentNote
            };
        }
        else {
            return {
                sectionName: portfolioRebateContent.superPensionSectionHeader,
                helpText: portfolioRebateContent.superPensionHelp,
                labelText: 'Which investment option would you like any portfolio rebate to be paid to, if applicable?',
                noteText: portfolioRebateContent.superPensionNote
            };
        }
    },

    getIsLinkAccountSectionHidden: function (productId, accountType) {
        const isInvestment = Products.isInvestment(productId);
        const isJoint = accountType === ApplicationConstants.AccountTypeCodes.JOINT;
        const isTrustOrFund = accountType === ApplicationConstants.AccountTypeCodes.SMSF ||
            accountType === ApplicationConstants.AccountTypeCodes.TRUST;

        return !(isInvestment && (isJoint || isTrustOrFund));
    },

    getInvestmentOptionListVisibility: function () {
        if (this.state.errorList && this.state.errorList.length > 0) {
            return true;
        }
        else if (this.state.portfolioRebateData.portfolioRebateOption !== PortfolioRebateConstants.PortfolioRebateValues.SELECT_OPTION && this.state.hideInvestmentOptionList) {
            return true;
        }
        else {
            return false;
        }
    },

    getRepaymentOptionData: function() {
        var data = PortfolioRebateConstants.RADIO_INPUT_DATA;
        var isDisabled = this.state.isSelectOptionDisabled;
        _.forEach(data,
            function(d) {
                if (d.id === PortfolioRebateConstants.PortfolioRebateValues.SELECT_OPTION) {
                    d['isDisabled'] = isDisabled;
                }
            });
        return data;
    },
        
    showSelectOptionDisabled() {
        return this.state.isSelectOptionDisabled
        ? <div className="special-requirement-link-message">Select option is not available because we don't have your investment option information at hand. To select an option provide your instructions in the <a onClick={this.switchToSpecialRequirementSection}>special request section</a> at the end of the form.</div>
        : null;
    },

    switchToSpecialRequirementSection: function() {
            Screen.moveToNextSection('specialRequestsSection');
    },

    render: function () {
        //get copy text
        const pageCopy = this.getCopyText(this.props.product.value, this.props.content.portfolioRebate);

        //get investment option list visibility
        const hideInvestmentOptionList = this.getInvestmentOptionListVisibility();

        // get account link section visibility
        const hideLinkSection = this.getIsLinkAccountSectionHidden(this.props.product.value, this.props.accountType);

        const repaymentOptionData = this.getRepaymentOptionData();

        const linkAccountOption = _.get(this.state, 'portfolioRebateData.linkAccountOption', '');

        return (
            <div className="form-step" id="portfolioRebateSection">
                <SectionHeader sectionName={pageCopy.sectionName} 
                               sectionHelpText={this.props.content.common.sectionHeaderHelp} 
                               NeedHelpInfo={pageCopy.helpText}
                               focus={this.props.focus} />
                <div className="container">
                    <div className="form-section">
                        <div id="portfolioRebateOptions" className="form-group portfolio-rebate-options">
                            <RadioInput id="portfolioRebateQuestion"
                                        label={pageCopy.labelText}
                                        note={pageCopy.noteText}
                                        data={repaymentOptionData}
                                        onChange={this.handlePortfolioRebateOptionChange}
                                        value={this.state.portfolioRebateData.portfolioRebateOption}
                                        customClass={this.state.isSelectOptionDisabled ? 'radio-button-list-has-description' : null}
                                        errorList={this.state.errorList} />
                            {this.showSelectOptionDisabled()}
                        </div>
                        <div id="rebatableOptions" className={classNames('form-group', { hidden: hideInvestmentOptionList }, {'portfolio-rebate-funds':!hideLinkSection})}>
                            <RadioButtonList data={this.state.rebatableOptionList}
                                             handleChange={this.handleInvestmentOptionChange}
                                             id="rebatableOptionList"
                                             label="Select an option"
                                             value={this.state.portfolioRebateData.investmentOption} />
                            <p>{this.props.content.portfolioRebate.investmentOptionListCopy}</p>
                        </div>
                        <InvestorRebateAccountOption linkAccountOption={linkAccountOption} hideLinkSection={hideLinkSection} />
                    </div>
                </div>
            </div>
        );
    }
});

module.exports = PortfolioRebateSection;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/PortfolioRebate/PortfolioRebateSection.jsx